export enum ContractStatus {
    YES,
    NO,
    CHECK
}
